import { QRCodeSVG } from 'qrcode.react';
import { useCopy } from '../../content';
import { useShopConfig } from '../../hooks/useShopConfig';

/**
 * QR to /w/{shortId} — the hand-off from the shared kiosk to the customer's
 * own phone.
 *
 * Shown for BOTH the assigned and waiting states. It matters in the chair
 * too, not just in line: a customer mid-cut still wants to know when they're
 * done, and it's the only way they keep any link once the kiosk resets
 * behind them.
 *
 * Post-A2P this is replaced by an SMS carrying the same link.
 *
 * There is no dark variant. There used to be a `dark` prop whose two
 * branches set identical classes — the card is a paper card on both the
 * navy kiosk and the paper phone page, because a QR needs a light quiet
 * zone to scan reliably either way.
 */
export default function QrHandoff({ shortId }: { shortId: string }) {
  const c = useCopy().kioskWalkIn.waiting;
  const { t } = useShopConfig();

  return (
    <div
      // grid + justify-items-center, not inline-block: the SVG is a
      // replaced element, so an inline-block card sat on the text baseline
      // and left more space under the code than above it.
      className="mx-auto mt-8 grid w-fit justify-items-center gap-3 rounded-card border border-edge-2 bg-paper p-6"
    >
      {/* Absolute URL, not window.location — the code is scanned by a phone
          that has no idea what host the kiosk is on. */}
      <QRCodeSVG value={`https://kdbarbershop.com/w/${shortId}`} size={140} />
      <p className="text-center text-[18px] text-slate-body">{t(c.scanHint)}</p>
    </div>
  );
}
